import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Loader from "../components/Loader";
import { useVerifyEmailMutation } from "../slices/usersApiSlice";

const VerifyEmailScreen = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("Verifying your email...");
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) {
      setStatus("error");
      setMessage("Verification token is missing.");
      return;
    }

    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;

    const run = async () => {
      try {
        const res = await verifyEmail(token).unwrap();
        setStatus("success");
        setMessage(res?.message || "Email verified successfully.");
        toast.success("Email verified. You can sign in now.");
      } catch (err) {
        const msg = err?.data?.message || err?.error || "Email verification failed.";
        setStatus("error");
        setMessage(msg);
        toast.error(msg);
      }
    };

    run();
  }, [params, verifyEmail]);

  return (
    <section className="mx-auto w-full max-w-xl">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
          Account
        </p>
        <h1 className="mb-3 text-3xl font-semibold text-slate-900">Email Verification</h1>
        <p
          className={`mb-4 text-sm ${
            status === "success"
              ? "text-emerald-700"
              : status === "error"
              ? "text-rose-700"
              : "text-slate-600"
          }`}
        >
          {message}
        </p>
        {isLoading || status === "pending" ? <Loader /> : null}
        <div className="mt-5">
          <Link
            to="/login"
            className="inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700"
          >
            Go to Sign In
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VerifyEmailScreen;
